{
  "loading": "Laadimine...",
  "placeholder": "Valige valikuline..."
}